import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LIMIT } from 'data/global';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import FilterActionWrapper from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/filters/FilterActionWrapper';
import { NavigationVariants } from 'models/Navigation';

import './NumberOfResultsPerPageFilter.styles.scss';

export const PER_PAGE = {
  25: '25',
  [DEFAULT_LIMIT]: DEFAULT_LIMIT,
  75: '75',
  100: '100',
} as const;

type NumberOfResultsPerPageFilterProps = {
  className?: string;
  variant?: NavigationVariants;
  limit: string;
  updateLimit: (limit: string) => void;
};

const NumberOfResultsPerPageFilter: React.FC<
  NumberOfResultsPerPageFilterProps
> = (props) => {
  const { className, variant, limit, updateLimit } = props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const classes = classNames('number-of-results-per-page-filter', className);

  const { t } = useTranslation();

  return (
    <FilterActionWrapper
      ref={dropdownRef}
      className={classes}
      variant={variant}
      trigerTitle={t('perPage', { count: +limit })}
    >
      <ul>
        {Object.entries(PER_PAGE).map(([key, val]) => (
          <li
            key={key}
            className={classNames({ selected: limit === val })}
            onClick={() => {
              dropdown.setIsOpen(false);
              updateLimit(val);
            }}
          >
            {t(key)}
          </li>
        ))}
      </ul>
    </FilterActionWrapper>
  );
};

export default NumberOfResultsPerPageFilter;
